import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Button } from '../../../components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';
import { toast } from 'sonner@2.0.3';

export type LogoPosition = 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';

interface TemplateLogoUploadProps {
  logoPreview: string;
  onLogoChange: (file: File, preview: string) => void;
  onLogoRemove?: () => void;
  logoPosition: LogoPosition;
  onLogoPositionChange: (position: LogoPosition) => void;
}

/**
 * Компонент для загрузки лого и выбора его позиции
 */
export function TemplateLogoUpload({
  logoPreview,
  onLogoChange,
  onLogoRemove,
  logoPosition,
  onLogoPositionChange,
}: TemplateLogoUploadProps) {
  const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast.error('Пожалуйста, выберите изображение');
        return;
      }

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        onLogoChange(file, reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="logoUpload">Лого (опционально)</Label>
      <div className="flex items-center gap-4">
        <Input
          key={logoPreview ? 'has-logo' : 'no-logo'}
          type="file"
          accept="image/*"
          onChange={handleLogoChange}
          id="logoUpload"
          className="flex-1"
        />
        {logoPreview && (
          <>
            <img
              src={logoPreview}
              alt="Logo preview"
              className="h-12 w-12 object-contain border rounded"
            />
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() => onLogoRemove?.()}
            >
              Убрать
            </Button>
          </>
        )}
      </div>
      <p className="text-xs text-muted-foreground">Загрузите изображение логотипа</p>
      
      {/* Позиция лого */}
      {logoPreview && (
        <div className="space-y-2 pt-2">
          <Label htmlFor="logoPosition">Расположение лого</Label>
          <Select
            value={logoPosition}
            onValueChange={(value) => onLogoPositionChange(value as LogoPosition)}
          >
            <SelectTrigger id="logoPosition">
              <SelectValue placeholder="Выберите позицию" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="top-left">Сверху слева</SelectItem>
              <SelectItem value="top-center">Сверху по середине</SelectItem>
              <SelectItem value="top-right">Сверху справа</SelectItem>
              <SelectItem value="bottom-left">Снизу слева</SelectItem>
              <SelectItem value="bottom-center">Снизу по середине</SelectItem>
              <SelectItem value="bottom-right">Снизу справа</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
